import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import Base = moment.unitOfTime.Base;
import {finalize, map, tap} from "rxjs/operators";
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService} from '../../../../../shared/src/lib/services/base.service';
import {AsyncPipe, DatePipe, NgForOf, NgIf, NgStyle} from '@angular/common';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-beach-status',
    templateUrl: './beach-status.component.html',
    styleUrls: ['./beach-status.component.css'],
    imports: [
        NgIf,
        AsyncPipe,
        NgForOf,
        NgStyle,
        NgbTooltipModule,
        DatePipe
    ]
})
export class BeachStatusComponent implements OnInit {

  loading = true;
  totalCurrentAdvisories = 0;
  items: Observable<any[]>;
  monitoringLocationService: BaseService;

  constructor(http: HttpClient) {
    this.monitoringLocationService = new BaseService(`${environment.baseUrl}/beaches/monitoringlocation`, http);
  }

  ngOnInit() {
    this.items = this.monitoringLocationService.get<any>('status').pipe(
      map((response) => response.results),
      tap((items) => this.totalCurrentAdvisories = items.filter(s => s.current.advisory_reported).length),
      finalize(() => this.loading = false)
    );
  }

}
